export default __webpack_public_path__ + "static/media/icon-20-icn-poi-arrival.2aa5f73a.svg";